import { H_RPQS_DASHBOARD, H_RPQS_OPTIONS } from 'account/constants/AccessRulesConstants'
import { ALIGN } from 'components/datatable/NewTable'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router'
import CollectivityAction from 'rpqs/actions/CollectivityAction'
import i18n from 'simple-react-i18n'

const ManagementEntityApp = () => {
    const dispatch = useDispatch()
    const { collectivityId, entityId } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/rpqs/collectivity/${collectivityId}/entity/${entityId}`,
            habilitation: H_RPQS_DASHBOARD,
        }, {
            icons: 'compare_arrows',
            name: i18n.descriptive,
            href: `/rpqs/collectivity/${collectivityId}/entity/${entityId}/descriptive`,
            habilitation: '',
        }, {
            icons: 'event',
            name: i18n.event,
            href: `/rpqs/collectivity/${collectivityId}/entity/${entityId}`,
            habilitation: '',
        }, {
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            href: `/rpqs/collectivity/${collectivityId}/entity/${entityId}`,
            habilitation: '',
        }, {
            icons: 'insert_chart',
            name: i18n.statistics,
            href: `/rpqs/collectivity/${collectivityId}/entity/${entityId}`,
            habilitation: '',
        }, {
            icons: 'settings',
            name: i18n.settings,
            href: '/rpqs/option',
            habilitation: H_RPQS_OPTIONS,
            position: ALIGN.BOTTOM,
        }]
    }, [collectivityId, entityId])

    useEffect(() => {
        dispatch(CollectivityAction.fetchManagementEntity(collectivityId, entityId))
        dispatch(CollectivityAction.fetchCollectivity(collectivityId))
        dispatch(CollectivityAction.fetchZones(collectivityId, entityId))
    }, [collectivityId, entityId, dispatch])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks}/>
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default ManagementEntityApp
